import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import { AssessmentDetails } from "Assessments";
import UnitPlanDetails from "UnitPlanDetails";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";

export default (store, pathName = "course-flow") => ({
  path: pathName,
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-flow" */ "./components"),
      import(
        /* webpackChunkName: "course-flow" */ "./modules/CourseFlowModule"
      ),
      import(
        /* webpackChunkName: "unit-planner" */ "IBPlanner/modules/IBPlannerModule"
      ),
      import(
        /* webpackChunkName: "course-flow" */ "./components/ImportFromAnotherCourseClassModal/modules/ImportModalModule"
      ),
    ]).then(
      ([
        importedModule0,
        importedModule1,
        importedModule2,
        importedModule3,
      ]) => {
        const component = importedModule0.default;
        const courseFlowReducer = importedModule1.default;
        const unitPlanReducer = importedModule2.default;
        const importFromCourseClassFlowModalReducer = importedModule3.default;

        injectReducer(store, {
          key: "courseFlow",
          reducer: courseFlowReducer,
        });

        injectReducer(store, {
          key: "planner",
          reducer: unitPlanReducer,
        });

        injectReducer(store, {
          key: "importFromCourseClassFlowModal",
          reducer: importFromCourseClassFlowModalReducer,
        });

        return component;
      }
    )
  ),
  childRoutes: [
    ClassRoomDetails(store),
    AssessmentDetails(store),
    UnitPlanDetails(store),
  ],
});
